import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/layouts/Header";
import styles from "../styleBlog/cssBlog/style.css";
import MeiliSearch from "meilisearch";
import ReactMarkdown from "react-markdown";
import { Link, useParams } from "react-router-dom";
import Moment from "react-moment";
import { getStrapiURL } from "../lib/api";

function BlogDetails1() {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [articleId, setArticleId] = useState(0);
  const [articleTitle, setArticleTitle] = useState("");
  const [article, setArticle] = useState("");
  const [relatedArticles, setRelatedArticles] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [commentsCount, setCommentsCount] = useState(0);
  const [comment, setComment] = useState("");
  const [commentName, setCommentName] = useState("");
  const [commentEmail, setCommentEmail] = useState("");
  let { id, title } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = getStrapiURL("/api/articles/" + id + "/custom");
        const res = await axios.get(url);
        console.log("single article data fetched", res.data);
        setArticle(res.data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    const fetchRelatedData = async () => {
      try {
        let url = getStrapiURL("/api/articles/" + id + "/related");
        const res = await axios.get(url);
        console.log("related articles data fetched", res.data);
        setRelatedArticles(res.data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
    fetchRelatedData();
    setArticleId(id);
    setArticleTitle(title);
  }, []);

  const fetchRelatedComments = async () => {
    try {
      let url = getStrapiURL("/api/comments/article/" + id);
      const res = await axios.get(url);
      console.log("related comments data fetched", res.data?.entries);
      setComments(res.data?.entries);
      setCommentsCount(res.data?.count);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRelatedComments();
  }, []);

  const headerToggler = (e) => {
    e.preventDefault();
    setToggleMenu(!toggleMenu);
  };

  document.addEventListener("click", function (e) {
    if (e.target.closest(".content")) {
      setToggleMenu(false);
    }
  });

  const Similaires = ({ article }) => {
    const { avatar, title, date, id, urlTitle } = article;
    console.log("title ", id);
    return (
      <>
        <div className="dlab-media">
          <img src={getStrapiURL(avatar?.url)} alt="image" />
        </div>
        <div className="dlab-info">
          <h4 className="title">
            <a href={"/blog/" + id + "/" + urlTitle}>{title}</a>
          </h4>
          <div className="dlab-meta">
            <ul>
              <li className="post-date">
                {" "}
                <Moment format="DD-MM-YYYY">{date}</Moment>{" "}
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  };

  const Comment = ({ comment }) => {
    return (
      <div className="comment-body">
        <div className="comment-author vcard">
          <img
            className="avatar photo"
            src="/images/hacker.png"
            alt="anonym comment image"
          />
          <cite className="fn">
            {comment.author
              ? comment?.author?.username
              : comment.name
              ? comment.name
              : "Anonyme"}
          </cite>
        </div>
        <p>{comment?.message}</p>
      </div>
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let data = {
      data: {
        message: comment,
        email: commentEmail,
        name: commentName,
        article: articleId,
      },
    };
    const postComment = async () => {
      try {
        let url = getStrapiURL("/api/comments");
        const res = await axios.post(url, data);
        console.log("comment posted", res.data);
        setLoading(false);
        setComment("");
        setCommentName("");
        setCommentEmail("");
        fetchRelatedComments();
      } catch (error) {
        console.log("wicked ", error);
        setError(error);
        setLoading(false);
      }
    };
    postComment();
  };

  return (
    <>
      <Header
        logoSource="/images/yabsLogoWhite.png"
        toggleMenu={toggleMenu}
        headerToggler={headerToggler}
      />
      <main className={toggleMenu ? "content open" : "content"}>
        <div className="blog-page-section">
          <div className="container">
            <div className="page-content bg-white">
              {/* <!-- Banner  --> */}
              <div
                className="dlab-bnr-inr overlay-black-middle"
                style={{
                  backgroundImage: `url(/images/dots-bg.svg)`,
                  padding: 0,
                }}
              >
                <div className="container">
                  <div className="dlab-bnr-inr-entry">
                    <h1>{article.title}</h1>
                    {/* <!-- Breadcrumb Row --> */}
                    <nav aria-label="breadcrumb">
                      <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                          <a href="/">Accueil</a>
                        </li>
                        <li className="breadcrumb-item active">
                          <a href="/blog">Blog</a>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          <a>{article.title}</a>
                        </li>
                      </ul>
                    </nav>
                    {/* <!-- Breadcrumb Row End --> */}
                  </div>
                </div>
              </div>
              {/* <!-- Banner End --> */}

              {/* <!-- Blog Large --> */}
              <section
                className="content-inner bg-img-fix"
                style={{
                  backgroundImage: "url(images/bg2.png)",
                  backgroundSize: "contain",
                }}
              >
                <div className="container">
                  <div className="row">
                    <div className="col-xl-8 col-lg-8 m-b50">
                      {/* <!-- blog start --> */}
                      <div className="dlab-blog blog-single style-1">
                        <div className="dlab-meta m-t10">
                          <ul>
                            <li className="post-date">
                              <i className="flaticon-clock m-r10"></i>
                              <Moment format="DD-MM-YYYY HH:mm:ss">
                                {article.date}
                              </Moment>
                            </li>
                            <li className="post-author">
                              <i className="flaticon-user m-r10"></i>By{" "}
                              <a href="javascript:void(0);">
                                {" "}
                                {article?.author?.username}
                              </a>
                            </li>
                          </ul>
                        </div>
                        <ReactMarkdown>{article.content}</ReactMarkdown>
                        <div className="dlab-meta border-top">
                          <ul>
                            {/* <li className="post-tags">
                              Tags:
                              <a href="javascript:void(0);">#Child </a> ,
                              <a href="javascript:void(0);">#Eduction </a> ,
                              <a href="javascript:void(0);">#Money </a> ,
                              <a href="javascript:void(0);">#Resturent </a>
                            </li> */}
                            <li className="post-comment">
                              <a href="javascript:void(0);">
                                <i className="flaticon-speech-bubble"></i>
                                <span>
                                  {commentsCount > 0 ? commentsCount : "Aucun"}
                                </span>
                              </a>
                            </li>
                            <li className="post-share">
                              <i className="flaticon-share"></i>
                              <ul>
                                <li>
                                  <a
                                    className="fa fa-facebook"
                                    href="https://en-gb.facebook.com/"
                                  ></a>
                                </li>
                                <li>
                                  <a
                                    className="fa fa-twitter"
                                    href="https://twitter.com/login?lang=en"
                                  ></a>
                                </li>
                                <li>
                                  <a
                                    className="fa fa-linkedin"
                                    href="https://www.linkedin.com/login"
                                  ></a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="clear" id="comment-list">
                        <div className="comments-area style-1" id="comments">
                          <h2 className="comments-title">
                            {commentsCount > 0 ? commentsCount : "Aucun"}{" "}
                            {"Commentaire(s)"}
                          </h2>
                          <div className="clearfix">
                            {/* <!-- comment list END --> */}
                            <ol className="comment-list">
                              <li className="comment">
                                {/* <!-- list END --> */}
                              </li>
                              {/* </ol> */}
                              {/* <!-- list END --> 
                              {/* </li> */}
                              {!!comments &&
                                comments?.map((com) => (
                                  <li className="comment" key={com?.id}>
                                    <Comment comment={com} />
                                  </li>
                                ))}
                            </ol>
                            {/* <!-- comment list END --> */}
                            {/* <!-- Form --> */}
                            <div
                              className="comment-respond style-1"
                              id="respond"
                            >
                              <h2
                                className="comment-reply-title"
                                id="reply-title"
                              >
                                Laissez un commentaire{" "}
                                <small>
                                  {" "}
                                  <a
                                    style={{ display: "none" }}
                                    href="javascript:void(0);"
                                    id="cancel-comment-reply-link"
                                    rel="nofollow"
                                  >
                                    Cancel reply
                                  </a>{" "}
                                </small>{" "}
                              </h2>
                              <form
                                className="comment-form"
                                onSubmit={handleSubmit}
                              >
                                <p className="comment-form-author">
                                  <label for="author">
                                    Nom <span className="required">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="Author"
                                    value={commentName}
                                    placeholder="Nom"
                                    id="author"
                                    onChange={(e) =>
                                      setCommentName(e.target.value)
                                    }
                                  />
                                </p>
                                <p className="comment-form-email">
                                  <label for="email">
                                    Email <span className="required">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Email"
                                    name="email"
                                    id="email"
                                    value={commentEmail}
                                    onChange={(e) =>
                                      setCommentEmail(e.target.value)
                                    }
                                  />
                                </p>
                                <p className="comment-form-comment">
                                  <label for="comment">Commentaire</label>
                                  <textarea
                                    rows="8"
                                    name="comment"
                                    placeholder="Commentaire"
                                    id="comment"
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                  ></textarea>
                                </p>
                                <p className="form-submit">
                                  <button
                                    type="submit"
                                    className="btn btn-link d-inline-flex align-items-center"
                                    id="submit"
                                  >
                                    <i className="fa fa-angle-right m-r10"></i>
                                    Publier
                                  </button>
                                </p>
                              </form>
                            </div>
                            {/* <!-- Form --> */}
                          </div>
                        </div>
                      </div>
                      {/* <!-- blog END --> */}
                    </div>
                    {relatedArticles.length > 0 && (
                      <div className="col-xl-4 col-lg-4 m-b30">
                        <aside className="side-bar sticky-top">
                          <div className="widget recent-posts-entry">
                            <h2 className="widget-title">Similaires</h2>
                            {relatedArticles?.map((ra) => (
                              <div className="widget-post clearfix" key={ra.id}>
                                <Similaires article={ra} />
                              </div>
                            ))}
                          </div>
                        </aside>
                      </div>
                    )}
                  </div>
                </div>
              </section>

              {/* <!-- Call To Action --> */}
              {/* <Cta /> */}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default BlogDetails1;
